import React, { Component } from 'react';
import { Table, Input } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { HeaderTableMasterDataTransportation } from '../../../../components/table/headerTabel';
import {
  datasetPagination,
  getNumberFromTo,
} from '../../../../scripts/pagination';
import FilterData from '../../../../scripts/filterDataTable';
import Pagination from '../../../../components/common/pagination';

class TableMasterDataTransportationUnit extends Component {
  constructor(props) {
    super(props);
    this.currentIndex = 0;
    this.state = {
      searchInput: '',
      activePage: 1,
    };
  }
  static propTypes = {
    data: PropTypes.array,
  };
  handleChange = (e, { name, value }) => this.setState({ [name]: value });
  pageChange = (e, { activePage }) => {
    this.setState({ activePage });
  };
  render() {
    let filterData = FilterData(
      this.props.listData,
      'Name',
      this.state.searchInput
    );
    let pagedData = datasetPagination(filterData, 3);
    let listData = pagedData[this.state.activePage - 1];
    const props = this.props;

    let { numbersFrom, numbersTo } = getNumberFromTo(
      listData,
      this.state.activePage,
      3
    );
    return (
      <div>
        <Input
          icon="search"
          placeholder="search"
          name="searchInput"
          value={this.state.searchInput}
          onChange={this.handleChange}
        />
        <Table basic="very" selectable fixed>
          <div style={{ overflow: 'auto' }}>
            <Table.Header>
              <Table.Row>
                {HeaderTableMasterDataTransportation.map(
                  (headTableContent, index) => {
                    return (
                      <Table.HeaderCell key={index}>
                        {headTableContent}
                      </Table.HeaderCell>
                    );
                  }
                )}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {listData &&
                listData.map((transportation, idx) => {
                  return (
                    <Table.Row key={idx}>
                      <Table.Cell component="th" scope="row" width={1}>
                        {transportation.Name}
                      </Table.Cell>
                      {/* <Table.Cell> {transportation.Address}</Table.Cell> */}
                      <Table.Cell> {transportation.Code}</Table.Cell>
                      <Table.Cell> {transportation.CompanyCode}</Table.Cell>
                      <Table.Cell>
                        {transportation.TransportationTypeName}
                      </Table.Cell>
                      <Table.Cell>
                        {transportation.TransportationSeatType}
                      </Table.Cell>
                      <Table.Cell> {transportation.Rating}</Table.Cell>
                      <Table.Cell> {transportation.Currency}</Table.Cell>

                      <Table.Cell> {transportation.Price}</Table.Cell>
                      <Table.Cell> {transportation.StartDate}</Table.Cell>
                      <Table.Cell> {transportation.EndDate}</Table.Cell>
                      <Table.Cell>{transportation.Rank}</Table.Cell>
                      <Table.Cell> {transportation.ServiceType}</Table.Cell>
                      <Table.Cell> {transportation.Hours}</Table.Cell>
                      <Table.Cell> {transportation.Description}</Table.Cell>
                    </Table.Row>
                  );
                })}
            </Table.Body>
            {/* {pagedData &&
              pagedData.length > 1 && (
                <Table.Footer> */}
            <Pagination
              // totalPages={pagedData.length}
              // onPageChange={this.pageChange}
              // activePage={this.state.activePage}
              pagedData={pagedData}
              numbersTo={numbersTo}
              numbersFrom={numbersFrom}
              data={props.listData}
              pageChange={this.pageChange}
              activePage={this.state.activePage}
            />
            {/* </Table.Footer>
              )} */}
          </div>
        </Table>
      </div>
    );
  }
}

TableMasterDataTransportationUnit.propTypes = {
  listData: PropTypes.array,
};
export default TableMasterDataTransportationUnit;
